
import './App.css';
import Naturebeauty from './Components/Basics/Naturebeauty';

function App() {
  return (
    <div className="App">
      <Naturebeauty />
    </div>
  );
}

export default App;
